<template>
  <div id="paypal-button-container" />
</template>

<script>
  export default {
    name: 'PaypalButtonComponent',
    props: {
      form: {
        type: String,
        default: '#form-new-subscription',
      },
      submitEvent: {
        type: String,
        default: 't-event.ajax-new.subscription.submit',
      },
      loadedEvent: {
        type: String,
        default: 't-event.ajax-new.subscription.loaded',
      },
    },
    mounted() {
      this.$bus.$once(this.loadedEvent, this.setupPaypal);
    },
    methods: {
      setupPaypal() {
        const self = this;
        let savedActions = null;
        const validate = (actions) => {
          if (actions && actions.enable && actions.disable) {
            savedActions = actions;
          }
          const valid = document.querySelector(this.form).checkValidity();
          return valid ? savedActions.enable() : savedActions.disable();
        };

        if (this.$route.name === 'subscription.index' || this.$route.name === 'parameter') {
          this.$bus.$on('t-event.multiselect-change', validate);
        }
        window.$(document).on('change', `${this.form} [required]`, validate);
        // TODO handle VFG MultiSelect change

        const { env, client } = this.$config.parameters.paypal;
        window.paypal.Button.render({
          env,
          client,
          onClick: () => document.querySelector(this.form).reportValidity(),
          validate,
          style: {
            label: 'paypal',
            size: 'responsive',
            shape: 'rect',
            color: 'blue',
            tagline: false,
            fundingicons: true,
          },
          payment: (data, actions) => {
            const durationPrice = window.$(`${this.form} .multiselect`).find('.multiselect__single').text();
            const price = durationPrice.split(' - ')[1].split(' ');
            const number = price[0];
            const currency = _.get(this.get(), 'memorial.currency.code') || _.get(this.oauth(), 'user.memorial.currency.code');

            return actions.payment.create({
              payment: {
                transactions: [{
                  amount: { total: number, currency },
                }],
              },
            });
          },
          onAuthorize: (data, actions) => actions.payment.execute().then(() => {
            self.$bus.$emit(this.submitEvent, { transaction: JSON.stringify(data) });
          }),
        }, '#paypal-button-container').then((component) => {
          component.container.click();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/components/PaypalButton.vue